<template>
    <div>
        <spinner v-if="loading" size="200"/>
        <template v-else>
            <h1>Vos Communications</h1>
            <div class="mt-3 toolsContainer">
                <template v-for="adminCat of adminCategories">
                    <div v-if="sortedDocuments[adminCat.id].length"
                         :key="adminCat.id" class="documentSection"
                    >
                        <AppSwiper :slides="sortedDocuments[adminCat.id]"
                                   :title="adminCat.name" mode="normal"
                        />
                    </div>
                </template>
            </div>
        </template>
    </div>
</template>

<script>
import {apiCallRebuild, notifyErrorFetchRaw} from "@/helper";
import {API_ROUTES} from "@/Services/api.common.service";
import {ADMIN_CATEGORIES, OFFERS_CATEGORY_ID} from "@/setup.const";
import AppSwiper from "@/views/Communication/AppSwiper";
import "swiper/css/swiper.css";

export default {
    components: {AppSwiper},
    data() {
        return {
            loading: true,
            adminCategories: ADMIN_CATEGORIES,
            sortedDocuments: {},
        };
    },
    watch: {$route: "fetchData"},
    created() {
        this.fetchData();
    },
    methods: {
        async fetchData() {
            const notifyError = notifyErrorFetchRaw.bind(this);

            try {
                const resApi = await apiCallRebuild(API_ROUTES.communication);
                const documents = resApi?.documents?.documents || [];
                const activeDocument = documents.filter((doc) => doc.visible);
                const sortedDocuments = {};

                const filterDocumentByAdminCategories = (adminCategory) =>
                    activeDocument.filter((el) => el.adminCategory === adminCategory);

                this.adminCategories = this.adminCategories.filter(category => OFFERS_CATEGORY_ID !== category.id);
                this.adminCategories.forEach(({id}) => {
                    const dateCmp = (a, b) => new Date(b.date) - new Date(a.date);

                    sortedDocuments[id] =
                        filterDocumentByAdminCategories(id).sort(dateCmp);
                });

                this.sortedDocuments = sortedDocuments;
                this.loading = false;
            } catch (e) {
                console.error(e);
                notifyError();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
h1 {
    font-size: 3.5em;
    margin-bottom: 80px;
}

.toolsContainer {
    padding: 0 9rem 0 1rem;

    .documentSection:first-child {
        margin-bottom: max(50px, 6vh);
    }
}
</style>
